module.exports = __webpack_public_path__ + "static/media/search_iteration_surveys_1.9abdb502.png";